import { apiClient } from "lib/apiClient";

export type IGooglePlaceCandidate = {
  placeId: string;
  businessName: string;
  rating: number;
  reviewCount: number;
  category: string;
  address: string;
  businessStatus: string;
  phone: string;
  website: string;
  latestReviewSnippet: string | null;
};

export const getGooglePlaceCandidates = async (
  propertyId: string
): Promise<IGooglePlaceCandidate[]> => {
  const response = await apiClient.get(
    `/properties/${propertyId}/get-google-place-candidates`
  );

  return response.data;
};
